import { type SxProps, type Theme, Typography, type TypographyProps } from '@mui/material';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType } from '@repo/segment/enums';
import type { AnalyticsType } from '@repo/segment/types';
import { EntityPlacementCtaTypeEnum } from '@repo/supergraph/marketplace/enums';
import type { CtaType, ImageType } from '@repo/supergraph/marketplace/types';
import { CPCButton } from '@repo/ui/CPCComponents/CPCButton';

type CtaNameProps = {
  cta: CtaType;
  ctaAnalytics: AnalyticsType;
  displayName?: string;
  image?: ImageType;
  shouldShowModal?: boolean;
  modalVariant?: 'cpc' | 'wealthfront';
  variant?: TypographyProps['variant'];
  sx?: SxProps<Theme>;
};

export const CtaName = ({
  cta,
  ctaAnalytics,
  displayName,
  image,
  shouldShowModal = false,
  modalVariant = 'cpc',
  variant,
  sx,
}: CtaNameProps) => {
  if (!cta) return null;

  if (shouldShowModal) {
    return (
      <CPCButton
        modalVariant={modalVariant}
        buttonAnalytics={{
          actionName: 'product_card_product_modal_title_clicked',
          impressionSection: 'product_card_product_modal_title',
        }}
        cta={cta}
        analyticsPayload={ctaAnalytics}
        displayName={displayName}
        image={image}
        variant="link"
        buttonStyles={{
          padding: 0,
        }}
      >
        <Typography
          variant="boxHeadline"
          sx={{
            fontWeight: 700,
            ...(shouldShowModal && {
              color: 'text.primary',
            }),
          }}
        >
          {displayName}
        </Typography>
      </CPCButton>
    );
  }

  return (
    <CtaLink
      cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductName }}
      monetizable={ctaAnalytics.monetizable}
      analyticsPayload={ctaAnalytics}
      linkType={LinkType.PRODUCT_NAME}
      Component={Typography}
      variant={variant}
      sx={{
        color: 'text.primary',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
        ...sx,
      }}
    >
      {displayName}
    </CtaLink>
  );
};
